import { render, staticRenderFns } from "./AddMakeupClassMultipleModal.vue?vue&type=template&id=3bce4040&scoped=true&"
import script from "./AddMakeupClassMultipleModal.vue?vue&type=script&lang=ts&"
export * from "./AddMakeupClassMultipleModal.vue?vue&type=script&lang=ts&"
import style0 from "./AddMakeupClassMultipleModal.vue?vue&type=style&index=0&id=3bce4040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bce4040",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/tommy/Documents/BrocheBallet/studio-manager/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3bce4040')) {
      api.createRecord('3bce4040', component.options)
    } else {
      api.reload('3bce4040', component.options)
    }
    module.hot.accept("./AddMakeupClassMultipleModal.vue?vue&type=template&id=3bce4040&scoped=true&", function () {
      api.rerender('3bce4040', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dancers/credits/components/AddMakeupClassMultipleModal.vue"
export default component.exports